<template>
  <div class="icon icon-brighten-contrast" v-html="IconBrightenContrast"></div>
</template>

<script>
import IconBrightenContrast from './icon-brighten-contrast.svg'
export default {
  data () {
    return {
      IconBrightenContrast: IconBrightenContrast
    }
  }
}
</script>
<style lang='scss'>
.icon-brighten-contrast{
  svg{
    .bc-a,.bc-b,.bc-d{
      fill:none;
    }
    .bc-a,.bc-b{
      stroke:#000;
      stroke-width:1.5px;
    }
    .bc-b{
      stroke-linecap:round;
    }
    .bc-c{
      stroke:none;
    }
  }
  &.selected{
    svg{
      .bc-a,.bc-b{
        stroke:#0000FF;
        stroke-width:1.5px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// uncommon-client/components/svgs/IconBrightenContrast.vue